import { useEffect } from 'react'

/**
 * Modal-overlay dismissal behaviour: Escape closes, and body scroll is locked
 * while open. Shared by the app's modals so the two behaviours can't drift.
 * Inert while `isOpen` is false.
 */
export const useOverlayDismiss = (isOpen: boolean, onClose: () => void): void => {
	useEffect(() => {
		if (!isOpen) return

		const handleEscape = (e: KeyboardEvent) => {
			if (e.key === 'Escape') onClose()
		}

		document.addEventListener('keydown', handleEscape)
		document.body.style.overflow = 'hidden'

		return () => {
			document.removeEventListener('keydown', handleEscape)
			document.body.style.overflow = 'unset'
		}
	}, [isOpen, onClose])
}
